<template>
  <el-drawer
    title="机构详情"
    append-to-body
    :close-on-press-escape="false"
    :visible.sync="show"
    size="640px"
    direction="rtl">
    <div
      v-loading="loading"
      class="detail-drawer-wrap">
      <el-form label-width="85px">
        <el-form-item label="机构名称：">{{ ruleForm.servOrgName }}</el-form-item>
        <el-form-item label="机构首图：">
          <image-list
            :list="ruleForm.image"
            :listType="3" />
        </el-form-item>
        <el-form-item label="机构地址："> {{ ruleForm.address }}</el-form-item>
        <el-form-item label="联系方式："> {{ ruleForm.contactPhone }}</el-form-item>
        <el-form-item label="机构官网：">
          <el-link
            type="primary"
            :underline="false"
            :href="ruleForm.homepage"
            target="_blank">{{ ruleForm.homepage }}</el-link>
        </el-form-item>
        <el-form-item label="机构简介：">
          <div style="line-height: 1.4;">{{ ruleForm.introduction }}</div>
        </el-form-item>
        <el-form-item label="机构详情：">
          <desc-images v-model="ruleForm.contentImages"></desc-images>
        </el-form-item>
        <el-form-item label="机构服务：">
          <el-table
            border
            :data="ruleForm.servs">
            <el-table-column
              label="服务名称"
              prop="servName"
              min-width="160"> </el-table-column>
            <el-table-column
              label="分类"
              min-width="80"
              prop="className"> </el-table-column>
          </el-table>
        </el-form-item>
        <!-- <el-divider>员工</el-divider>
        <el-form-item label="员工信息：">
          <org-staff-table ref="staff" />
        </el-form-item> -->
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import ImageList from '@/components/image-list.vue'
import DescImages from '@/components/public/desc-images.vue'
// import OrgStaffTable from './org-staff-table.vue'
import OrgService from '@/service/org-service'
export default {
  name: 'DetailDrawer',
  components: { ImageList, DescImages },
  data() {
    return { show: false, loading: false, config: { id: null }, ruleForm: { image: '', contentImages: [] }}
  },
  methods: {
    fetchInfo() {
      this.loading = true
      OrgService.getservorg({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, contentImages } = res.data
          if (result === 0) {
            this.$set(this, 'ruleForm', {
              ...res.data,
              contentImages: this.$splitImage(contentImages)
            })
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(options) {
      this.config = { ...this.config, ...options }
      this.show = true
      this.fetchInfo()
      // this.$nextTick(() => {
      //   this.$refs.staff.fetch({ orgId: options.id })
      // })
    }
  }
}
</script>
